const config = {
  language:'en',
  userrole:'admin',
  user_email:'user@useremail.com',
  environment:'dev',
  API_BASE_URL : 'https://bxapiidentitydev.azurewebsites.net/api/v1/',
  loginPassObj: {
    type:'login',
    usernameField: true,
    passwordField: true,
    confirmPassField: false,
    oldPassField:false,
    rememberMeField:true,
    passwordValidatorField: false,
    loginPaswordValidation:true
  }, 
  registerPassObj: {
    type:'register',
    usernameField: false,
    passwordField: true,
    confirmPassField: true,
    oldPassField:false,
    rememberMeField:false,
    passwordValidatorField: true,
    loginPaswordValidation:false
  }, 
  changePassObj:{
    type:'changePassword',
    usernameField: false,
    passwordField: true,
    confirmPassField: true,
    oldPassField:true,
    rememberMeField:false,
    passwordValidatorField: true
  }  
};

export default config;